import { Controller } from '@hotwired/stimulus';

// Copies on arrival — a link just minted (hq/users access_link, nbe's teams/show invite). The
// Convite click is still a fresh gesture when Turbo lands here, so most
// browsers let the write through and the "copied" line shows; one that
// refuses says nothing, and the copy button beside the link is the way.
export default class extends Controller {
  static values = { text: String };
  static targets = ['done'];

  async connect() {
    try {
      await navigator.clipboard.writeText(this.textValue);
      if (this.hasDoneTarget) this.doneTarget.hidden = false;
    } catch {
      // refused (no gesture left, plain http): the button stays
    }
  }
}
